import { render, staticRenderFns } from "./CleanDesk.vue?vue&type=template&id=00bb9b44&scoped=true"
import script from "./CleanDesk.ts?vue&type=script&lang=ts&external"
export * from "./CleanDesk.ts?vue&type=script&lang=ts&external"
import style0 from "./CleanDesk.vue?vue&type=style&index=0&id=00bb9b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb9b44",
  null
  
)

export default component.exports